module.exports = __webpack_public_path__ + "img/ic_status_middle.de7c3536.svg";